module.exports = __webpack_public_path__ + "img/insta11.1bbd9336.jpg";